import { z } from 'zod';
import { bcp47, timestamp, uuid } from './common.js';
import { listQueryInput, paginated } from './list.js';
/**
 * Public-domain corpus (F5). Sourced from Project Gutenberg / Standard Ebooks
 * ONLY — never z-lib (hard rule §15).
 */
export const publicDomainSource = z.enum(['gutenberg', 'standard_ebooks']);
export const publicDomainBookSchema = z.object({
    id: uuid,
    source: publicDomainSource,
    /** Source-native id (e.g. Gutenberg ebook number) — unique per source. */
    sourceRef: z.string().min(1),
    title: z.string().min(1).max(500),
    author: z.string().max(300).nullable(),
    language: bcp47,
    /** S3 key of the ingested source text, if fetched. */
    sourceFileId: uuid.nullable(),
    coverFileId: uuid.nullable(),
    createdAt: timestamp,
});
// --- browse (F5 source picker: F-Estep step ③ / F-Echat "suggested sources") --
export const corpusSortColumns = ['title', 'author', 'createdAt'];
/** `corpus.list` — search title/author/language over `public_domain_books` (§5.9). */
export const corpusListQuery = listQueryInput(corpusSortColumns, {
    defaultSort: 'title',
    defaultDir: 'asc',
}).extend({
    source: publicDomainSource.optional(),
    language: bcp47.optional(),
});
export const corpusListResult = paginated(publicDomainBookSchema);
export const corpusGetInput = z.object({ bookId: uuid });
